document.addEventListener('ShoptetDOMContentLoaded', function() {
    renderCategoryImage(window.location.pathname);
    customCategory();
}); 
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    renderCategoryImage(window.location.pathname);
    customCategory();
}); 
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    renderCategoryImage(window.location.pathname);  
    customCategory();
}); 
$(document).ready(function(){
    renderCategoryImage(window.location.pathname);  
    customCategory();

}); 

function customCategory(){
    $('.categoryCount').remove();
    var customCount = sklonujPolozka($('#category-header>div>strong').text().trim())
    var currentPage = $('.pagination strong.current').text();
    var lastPage = $('.pagination a[data-testid="linkLastPage"]').text()
    $('#category-header').append('<div class="categoryCount">Stránka <strong>'+currentPage+' z '+lastPage+'</strong> - '+customCount+'</div>');
    if($('.category__secondDescription').length){
        if(!$('.content-wrapper-in>.category__secondDescription').length){
            $('.type-category .benefitBanner').before($('.category__secondDescription'))
        }
    }
    if($('.filtrationAndSlider').length){
        $('.category-top .filtrationAndSlider').remove();
        if(!$('.category-top .filtrationAndSlider').length){
            
            $('.category-top').append($('.filtrationAndSlider').clone());
            setTimeout(function(){
                //$('.benefitBanner.position--benefitCategory .filtrationAndSlider').remove();

            }, 1000)
        }
    }
    if($('.type-category').length){
        $('.benefitBanner').before($('footer#footer .reviews'))
    }
}


function renderCategoryImage(url) {
    var matchedImg = null;
    $.each(urlMap, function(key, img) {
      if (url.indexOf(key) !== -1) {
        matchedImg = img;
        return false;
      }
    });
    if (matchedImg) {
        var title = $('h1.category-title').first().text();
        var $breadcrumbs = $('.breadcrumbs').length 
            ? $('.breadcrumbs').clone() 
            : '';
        var description = $('.category-perex').length ? $('.category-perex').clone() : '';
        var $div = $('<div class="customCategory" style="background:url('+matchedImg+');background-size:cover;"><div class="container"><div class="inner"></div></div></div>');
        if ($div.find('.breadcrumbs').length === 0) {
            $div.find('.inner').append($breadcrumbs);
        }
        if ($div.find('h1.category-title').length === 0) {
            $div.find('.inner').append('<h1 class="category-title">'+title+'</h1>');
        }
        if ($div.find('.category-perex').length === 0) {
            $div.find('.inner').append(description);
        }
        $('body').addClass('superCategory')
        if(!$('.customCategory').length){
            $('header').after($div);
        }
        
    }
}

function sklonujPolozka(count) {
    count = parseInt(count, 10);
    if (count === 1) {
        return count + " položka";
    } else if (count >= 2 && count <= 4) {
        return count + " položky";
    } else {
        return count + " položek";
    }
}